/**
 * Custom hook to derive Plan Details state based on user's coverage type.
 *
 * Determines whether the user has spending account only coverage and calculates if
 * Benefits card or plan details should be shown
 *
 * @param {Object} meta - User metadata object from Redux store
 * @param {number} meta.isSpendingAccountOnly - Flag indicating if user has only spending account coverage (1 = true, 0 = false)
 * @param {number} meta.isMarketplaceOnly - Flag indicating if user is in a marketplace only group (1 = true, 0 = false)
 * @returns {Object} Plan details state configuration
 * @returns {boolean} returns.isBenefitsCardHidden - Whether to hide the benefits card toggle option
 */
export const usePlanDetailsState = (meta) => {
    const isSpendingAccountOnly = meta.isSpendingAccountOnly === 1;
    const isMarketplaceOnly = meta.isMarketplaceOnly === 1;
    const isBenefitsCardHidden = isSpendingAccountOnly || isMarketplaceOnly;
  
    return {
        isBenefitsCardHidden
    };
};